exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-name-cell .can-download[data-v-6a6d8b91] {\n  cursor: pointer;\n  user-select: none;\n}\n.file-name-cell .file-name[data-v-6a6d8b91] {\n  display: inline-block;\n  margin-right: 0.052083rem;\n}\n.file-name-cell .can-download[data-v-6a6d8b91]:hover {\n  color: rgb(120, 120, 195);\n  text-decoration: underline;\n}\n[data-v-6a6d8b91] .kp-update-row {\n  background: #0091da;\n  color: #FFFFFF;\n}\n[data-v-6a6d8b91] .el-table tr:hover {\n  color: #636363;\n}\n.delete[data-v-6a6d8b91] {\n  color: #fd349c;\n  cursor: pointer;\n}\n.el-icon-download[data-v-6a6d8b91] {\n  color: #3879EB;\n}", ""]);

// exports
